<template>
  <v-row no-gutters justify="center" align="start">
    <div class="n-container-medium">
      <router-view></router-view>
    </div>
  </v-row>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(`ui/indeegoSettings`, [
      `tabs`,
    ]),
  },
  methods: {
    goToFirstTab() {
      if (this.$route.name === `indeegoSettings`) {
        this.$router.replace(this.tabs[0].path);
      }
    },
  },
  beforeMount() {
    this.goToFirstTab();
  },
};
</script>

<style lang="scss">

  @import "@/scss/variables.scss";

  // .admin-list-actions {
  //   .v-icon {
  //     font-size: 20px !important;
  //   }
  // }

  .left-indeego-settings-nav {
    ul {
      background-color: #FFF;
      list-style: none;
      padding-left: 0px !important;
      border: 1px solid #DDDDDD;
      border-radius: $contentCardRadius;

      li {
        padding: 10px 18px;
        &:first-child {
          border-radius: $contentCardRadius $contentCardRadius 0px 0px;
        }
        &:last-child {
          border-radius: 0px 0px $contentCardRadius $contentCardRadius;
        }
        &:not(:last-child) {
          border-bottom: 1px solid #DDDDDD;
        }
        &:hover {
          background-color: #EEEEEE;
          cursor: pointer;
          .v-icon {
            color: #777;
            display: block;
          }
        }
        &.active {
          background-color: $primaryColor;
          color: #FFF;
          font-weight: 500;
          .v-icon {
            color: #FFF;
            display: block;
          }
        }
        .v-icon {
          display: none;
        }
      }
    }
  }
</style>
